import React, { Component } from 'react';
import upsolveStats from '../../../content/onBuild/upsolveStats.json';

export default class DebtIncrementer extends Component {
  constructor(props) {
    super(props);
    this.state = { debt: props.debt || upsolveStats.debtCleared.total };
  }

  componentDidMount() {
    setInterval(() => this.setState({ debt: this.state.debt + 1.157 }), 200);
  }

  render() {
    return Number(this.state.debt).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
}